(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    var sections = document.querySelectorAll('[data-product-tabs]');
    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.product-tabs__tab');
      var panels = section.querySelectorAll('.product-tabs__panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('aria-hidden', 'true');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          var panel = section.querySelector('#ptab-' + idx);
          if (panel) {
            panel.classList.add('is-active');
            panel.setAttribute('aria-hidden', 'false');
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
